

function PageLoading() {
  return (
    <div>
      loading...
    </div>
  );
}

export default PageLoading;
